import { render, staticRenderFns } from "./financialStatement.vue?vue&type=template&id=070267d1&scoped=true&"
import script from "./financialStatement.vue?vue&type=script&lang=js&"
export * from "./financialStatement.vue?vue&type=script&lang=js&"
import style0 from "./financialStatement.vue?vue&type=style&index=0&id=070267d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070267d1",
  null
  
)

export default component.exports